<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/o9lh2o/tc-custom/9781488079283.jpg?1740532993896" alt="This image is the cover for the book Long, Tall Texans: Calhoun, Long, Tall Texans"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Long, Tall Texans: Calhoun, Long, Tall Texans
      </h1>
      <p class="bookDescription body article font2">
        <b>From a <i>New York Times</i>–bestselling author, a cowboy struggles with his feelings for the woman who was once his ward in this small town Texas romance.</b><br/><br/>Orphaned as a child, Abby Clark learned not to rely on many people—except the Ballenger brothers, who were her rocks and her providers. But she’s not the little girl they once knew. Now, nearly twenty-one years old, Abby is a woman grown, and she knows what she wants: sexy cattleman Calhoun Ballenger. He insists on keeping her under his thumb, so Abby resolves to teach Calhoun a lesson. With the fury of a South Texas twister, she devises a plan to prove her independence—and capture his attention. Can Abby make Calhoun her very own cowboy?<br/><br/><b>Praise for Diana Palmer</b><br/><br/>“Palmer knows how to make the sparks fly.” —<i>Publishers Weekly</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Diana Palmer
      </h2>
      
      <p class="authorDescription body article">The prolific author of more than one hundred books, Diana Palmer got her start as a newspaper reporter. A New York Times bestselling author and voted one of the top ten romance writers in America, she has a gift for telling the most sensual tales with charm and humor. Diana lives with her family in Cornelia, Georgia.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin Enterprises Limited
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4a3d59e9